import Profile from "./components/Profile.jsx";
import "./App.css";

function App() {
  return (
    <div>
      <Profile />
    </div>
  );
}

export default App;
